import { render } from "./TelegramBanner.vue?vue&type=template&id=3b06c8b3&ts=true"
import script from "./TelegramBanner.vue?vue&type=script&lang=ts"
export * from "./TelegramBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__